import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

import { ShineLogoBw } from 'assets/images'

import styles from './styles.module.css'

const LayzImage = ({ ...props }) => {
  return (
    <LazyLoadImage
      wrapperClassName={styles.container}
      visibleByDefault={true}
      placeholderSrc={ShineLogoBw}
      {...props}
    />
  )
}

export default LayzImage
